import { DatePicker } from 'antd'
import momentGenerateConfig from 'rc-picker/lib/generate/moment'

// The DST bug: on a clock-forward day (e.g. Cairo Apr 24), midnight 00:00
// does not exist. rc-picker builds the calendar grid by:
//   1. setDate(pickerValue, 1)       → 1st of month at 00:00
//   2. addDate(monthStart, -N)       → walk back to week start
//   3. addDate(baseDate, offset)     → iterate all 42 cells
// If pickerValue or any intermediate date lands on a DST midnight, moment
// shifts it forward by 1 hour which rolls the date forward by one day,
// causing a day to appear twice and the DST day to be skipped.
//
// Fix: keep every date anchored at noon (12:00) throughout the grid.
// Noon is never inside a DST gap (gaps are always 1hr at midnight),
// so every constructed date is always valid regardless of timezone.
const dstSafeConfig = {
  ...momentGenerateConfig,

  // Parses 'YYYY-MM-DD' string into a moment — anchor at noon
  getFixedDate: str =>
    momentGenerateConfig
      .getFixedDate(str)
      .hour(12)
      .minute(0)
      .second(0)
      .millisecond(0),

  // Sets the day-of-month on an existing moment — re-anchor at noon
  // rc-picker calls this to get the 1st of the month as the grid base
  setDate: (date, num) =>
    momentGenerateConfig
      .setDate(date, num)
      .hour(12)
      .minute(0)
      .second(0)
      .millisecond(0),

  // Adds days to an existing moment — re-anchor at noon
  // rc-picker calls this to walk back to week start and iterate all 42 cells
  addDate: (date, diff) =>
    momentGenerateConfig
      .addDate(date, diff)
      .hour(12)
      .minute(0)
      .second(0)
      .millisecond(0)
}

const MomentDatePicker = DatePicker.generatePicker(dstSafeConfig)

export default MomentDatePicker
